/**
 * @desc 过滤页面中有切换的子页面
 */

const FILTER_TAGS = [
  // 数据总表
  { name: '仓库维度', url: '/home/data-report/warehouseDimension'},
  { name: '客户维度', url: '/home/data-report/customerDimension'},
  // 质量报表
  { name: '发货数据', url: '/home/production-data/shipment-data'},
  { name: '揽收数据', url: '/home/production-data/after-sale' },
  // 盈利报表
  { name: '科目明细', url: '/home/profitIndex/profit/account-details' },
  { name: '项目明细', url: '/home/profitIndex/profit/project-details' },
  // 物流账单
  { name: '日账单', url: '/operate/dues/logisticsBill/logisticsDateBill' },
  { name: '月账单', url: '/operate/dues/logisticsBill/logisticsMonthBill' },
  // 人力账单
  { name: '日账单', url: '/operate/dues/hrBill/hrDateBill' },
  { name: '月账单', url: '/operate/dues/hrBill/hrMonthBill' },
  // 客户账单
  { name: '日账单', url: '/operate/finance/customerBill/customerDateBill' },
  { name: '月账单', url: '/operate/finance/customerBill/customerMonthBill' },
  // 物流核验
  { name: '重量核验', url: '/operate/finance/logisticsVerification/weightVerification' },
  { name: '金额核验', url: '/operate/finance/logisticsVerification/amountVerification' },
  { name: '物流加收费', url: '/operate/finance/logisticsVerification/logisticsPlusCharges' },
  // 班组管理
  { name: '班组详情', url: '/production/bulk/team/team-details' },
  { name: '组长管理', url: '/production/bulk/team/headman-manage' },
  // 用户管理
  { name: '用户管理', url: '/system-settings/user-manage/user-list' },
  { name: '投资人管理', url: '/system-settings/user-manage/invenstment-list' },
]

export default FILTER_TAGS